import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import SVG from "react-inlinesvg";

const SVGImg = ({file, alt}) => {
	return <img src={'/img/' + file} className="center" alt={alt}/>
}

class Lagen extends React.Component {
  constructor(props) {
    super(props)
    this.state = {actieveLaag: props.lagen[0].naam[props.taal]}
	this.lagen = {}
	props.lagen.forEach(laag => 
		this.lagen[laag.naam[props.taal]] = laag
	)
  }

  laagselectie = evt => {
		this.lagen[this.state.actieveLaag].ids.forEach(id => document.getElementById(id).style="display: none")
		this.setState({actieveLaag: evt.target.value})
		let ids = this.lagen[evt.target.value].ids;
		ids.forEach(id => document.getElementById(id).style="display: inline")
	}
  render() {
	let actieveLaag = this.state.actieveLaag;
    return <div className="lagen">
		{this.props.lagen.map(laag=>{
			return <label><input type="radio" name="laag" value={laag.naam[this.props.taal]} checked={actieveLaag === laag.naam[this.props.taal]} onChange={this.laagselectie}/>{laag.naam[this.props.taal]}</label>
		}
		)}
	</div>
  }
}

const SVGMetLagen = ({file, lagen, taal}) => {
	return <div className="center">
		<SVG src={'/img/' + file}/>
		<div>
			<Lagen lagen={lagen} taal={taal}/>
		</div>
	</div>
}

const Vorige = ({id, taal}) => {
	return <Link to={"../../" + taal + "/" + id}><svg width="20px" height="20px"><polygon points="0,10 10,20 10,0"  style={{fill: "aqua"}}/></svg></Link>
}

const Volgende = ({id, taal}) => {
	return <Link to={"../../" + taal + "/" + id}><svg width="20px" height="20px"><polygon points="0,0 0,20 10,10"  style={{fill: "aqua"}}/></svg></Link>
}

const kleurplaat = (file) => {
	return file.replace(".svg", "-wit.svg");
}

const Kleurplaat = ({metadata, taal}) => {
	if (typeof(metadata.kleurplaat) === 'undefined' || metadata.kleurplaat == null) {
		return ""
	}
	return <div className="kleurplaatLink"><a href={"/img/" + metadata.kleurplaat}> &gt;{taal=== 'nl' ? 'Kleurplaat' : 'Colouring page'}</a></div>
}

const Deviantart = ({metadata, taal}) => {
	if (typeof(metadata.deviantart) === 'undefined' || metadata.deviantart == null) {
		return ""
	}
	return	<div className="extLink"><a href={metadata.deviantart}>{taal==='nl' ? 'Bekijk via DeviantArt' : 'View on DeviantArt'}</a></div>
}

const OpenSea = ({metadata, taal}) => {
	if (typeof(metadata.opensea) === 'undefined' || metadata.opensea == null) {
		return ""
	}
	return	<div className="extLink"><a href={metadata.opensea}>{taal==='nl' ? 'Bekijk op OpenSea' : 'View on OpenSea'}</a></div>
}


const Wordpress = ({metadata, taal}) => {
	if (typeof(metadata.wordpress) === 'undefined' || metadata.wordpress == null) {
		return ""
	}
	return	<div className="tekstvak">{taal==='nl' ? 'Een illustratie voor het verhaal op ' : 'An illustration for the story on '}<a href={metadata.wordpress}> {metadata.wordpress}</a></div>
}

const Omschrijving = ({metadata, taal}) => {
	if (typeof(metadata[taal].omschrijving) === 'undefined' || metadata[taal].omschrijving == null) {
		return ""
	}
	return	<div className="tekstvak">{metadata[taal].omschrijving}</div>
}

export default ({ data, pageContext }) => {
  const metadata = data.metadataYaml
  const taal = pageContext.taal
  const keywords = typeof(metadata[taal].tags) === 'undefined' ? [] : [{
		property: "keywords", content: metadata[taal].tags.toString()
	}]
  return (
    <Layout taal={taal}>
		<SEO title={metadata[taal].titel} meta={keywords} description={metadata[taal].titel}/>
      <div>
        <h3 className="titel">{metadata[taal].titel}</h3>
		<div className="svgnav">
		{pageContext.vorige != null ? <Vorige id={pageContext.vorige} taal={taal}/> : ""}
		{(typeof(metadata.lagen) === 'undefined' || metadata.lagen == null) ? <SVGImg file={metadata.file} alt={metadata[taal].alt}/> : <SVGMetLagen file={metadata.file} lagen={metadata.lagen} taal={taal}/>}
		{pageContext.volgende != null ? <Volgende id={pageContext.volgende} taal={taal}/> : ""}
		</div>
		<Kleurplaat metadata={metadata} taal={taal}/>
		<Omschrijving metadata={metadata} taal={taal}/>
		<Wordpress metadata={metadata} taal={taal}/>
		<Deviantart metadata={metadata} taal={taal}/>
		<OpenSea metadata={metadata} taal={taal}/>
      </div>
    </Layout>
  )
}
export const query = graphql`
  query($id: String!) {
    metadataYaml(id: { eq: $id } ) {
      file
	  kleurplaat
	  deviantart
	  opensea
	  wordpress
      nl {
       titel
       omschrijving
       tags
       alt
      }
	  en {
       titel
       omschrijving
	   tags
	   alt
      }
      lagen {
        naam {
		 nl
         en
        }
        ids
      }
	  
    }
  }
`
